import React from "react";

import "./ContentsTwoColumn.css";

export default function Index({ data, firstColorRed, posName, multipleRow }) {
  return (
    <section className="contents-two-column-pos">
      <div className="container">
        {data.length > 0 ? (
          data.map((item, index) => {
            return (
              item.title &&
              item.text &&
              item.img && (
                // <div className="row">
                <div
                  className={
                    multipleRow ? "multipleRow" : "row flex-row-reverse odd"
                  }
                >


                  {multipleRow ? <div
                    className={`col-lg-3 col-sm-12 ${item.class ? item.class : null
                      }`}
                  >
                    {item.img && (
                      <div className="image-wrapper">
                        <img src={item.img} id={posName + index} class={posName} alt="MerchantService" />
                      </div>
                    )}
                    {item.high_light_text ? (
                      <div className="high-light-texts">
                        <ul className="d-flex">
                          {item.high_light_text.map(highLight => (
                            <li>{highLight}</li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                  </div> : null}



                  <div
                    className={`col-lg-9 col-sm-12 ${item.class ? item.class : null
                      }`}
                  >
                    <div className="text-wrapper">
                      <div className="table-cell">
                        {item.title && (
                          <div className="title">
                            <h2
                              className={
                                firstColorRed
                                  ? index % 2 !== 0
                                    ? "primary"
                                    : "accent"
                                  : index % 2 === 0
                                    ? "primary"
                                    : "accent"
                              }
                            >
                              {item.title}
                            </h2>
                          </div>
                        )}

                        {/* {item.text && Array.isArray(item.text) ? item.text.map((textItem, index) => <p key={index}>{textItem}</p>) : <p>{item.text}</p>} */}
                        {/* {item.text && <p>{item.text}</p>} */}
                        {item.text &&
                        Array.isArray(item.text) ? (
                          item.text.map((textItem, index) =>
                            // Check if the paragraph starts with "•"
                            textItem.startsWith("•") ? (
                              <div
                                key={index}
                                className="bullet-list-paragraph"
                              >
                                <p>{textItem.slice(1).trim()}</p>
                              </div>
                            ) : (
                              <p key={index}>{textItem}</p>
                            )
                          )
                        ) : item.text.startsWith("•") ? ( // Check if the single text item starts with "•"
                          <div className="bullet-list-paragraph">
                            <p>{item.text.slice(1).trim()}</p>
                          </div>
                        ) : (
                          <p>{item.text}</p>
                        )}
                        
                        {item.sub_text && <p>{item.sub_text}</p>}
                        {item.text_bold && (
                          <p className="text-bold">{item.text_bold}</p>
                        )}
                        {item.icon_contents ? (
                          <div className="icon-contents d-flex">
                            <item.icon_contents.icon />
                            <p>
                              <span className="stronger">
                                {item.icon_contents.title}
                              </span>
                              {item.icon_contents.text}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {multipleRow ? null : <div
                    className={`col-lg-3 col-sm-12 ${item.class ? item.class : null
                      }`}
                  >
                    {item.img && (
                      <div className="image-wrapper">
                        <img src={item.img} id={posName + index} class={posName} alt="MerchantService" />
                      </div>
                    )}
                    {item.high_light_text ? (
                      <div className="high-light-texts">
                        <ul className="d-flex">
                          {item.high_light_text.map(highLight => (
                            <li>{highLight}</li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                  </div>}
                </div>
              )
            );
          })
        ) : (
          <div className="row">
            <div
              className={`col-lg-9 col-sm-12 ${data.class ? data.class : null}`}
            >
              <div className="text-wrapper">
                <div className="title">
                  <h2 className="primary">{data.title}</h2>
                </div>
                {/* {data.text
                  ? data.text.map(textItem => <p key={textItem}>{textItem}</p>)
                  : null} */}
              </div>
            </div>
            <div
              className={`col-lg-3 col-sm-12 ${data.class ? data.class : null}`}
            >
              <div className="image-wrapper">
                <img src={data.img} id={posName + Index} class={posName} alt="MerchantService" />
              </div>
            </div>
          </div>
        )}
      </div>
    </section >
  );
}
